/* eslint-disable no-underscore-dangle */
import React from 'react';
import 'assets/css/reportingPageStyle.css';
import moment from 'moment-timezone';
import {
  Checkbox,
  Popover,
  Icon,
  Button,
  Row,
  Divider,
  Tabs,
  Radio,
  DatePicker,
} from 'antd';
import { SpH5 } from 'components/DesignKit';

const { TabPane } = Tabs;
const dateFormat = 'DD/MM/YYYY';
const MOMENT_FORMAT = 'YYYY-MM-DD';
class DateMenu extends React.Component {
  state = {
    icon: {},
    selectedItems: [],
    defaultBackgroundColor: '#fbfbfb',
    summaryType: 'Today',
    startDate: '',
    endDate: '',
    startD: '',
    endD: '',
  };

  componentDidMount = () => {
    if (this.props.value && this.props.value.length) {
      this.setState(
        {
          selectedItems: [...this.props.value],
        },
        () => this.checkIconFilled(),
      );
    }
  };

  checkIconFilled = () => {
    if (this.state.selectedItems.length) {
      this.setState({ icon: { theme: 'filled' } });
    } else {
      this.setState({ icon: {} });
    }
  };

  changeBackgroundColor = () => {
    if (this.state.defaultBackgroundColor === '#fbfbfb') {
      this.setState({ defaultBackgroundColor: '#e0e0e0' });
    } else {
      this.setState({ defaultBackgroundColor: '#fbfbfb' });
    }
  };

  updatePaymentType = (val) => {
    this.setState({ summaryType: val.target.value });
    this.props.searchAll(val.target.value);
  };

  handleStartDate = (date) => {
    // eslint-disable-next-line
      const Date = moment(date._d).format(MOMENT_FORMAT);
    this.setState({ startDate: Date });
    this.setState({ startD: date });
    if (Date && this.state.endD) {
      this.props.searchSelected(date, this.state.endD);
    }
  };

  handleEndDate = (date) => {
    // eslint-disable-next-line
      const Date = moment(date._d).format(MOMENT_FORMAT);
    this.setState({ endDate: Date });
    this.setState({ endD: date });
    if (Date && this.state.startD) {
      this.props.searchSelected(this.state.startD, date);
    }
  };

  dateboxRender = () => (
    <Checkbox.Group>
      <Row
        type="flex"
        style={{
          flexDirection: 'column',
          margin: '14px',
        }}
      >
        <Tabs defaultActiveKey="1" tabPosition="top" style={{ paddingBottom: '20px' }}>
          <TabPane tab="Floating Dates" key="1">
            <Radio.Group
              value={this.state.summaryType}
              onChange={value => this.updatePaymentType(value)}
              className="ml-4"
              buttonStyle="solid"
            >
              <Radio.Button value="Reset">Reset</Radio.Button>
              <Radio.Button value="Today">Today</Radio.Button>
              <Radio.Button value="Day">Previous Day</Radio.Button>
              <Radio.Button value="7Days">Last 7 Days</Radio.Button>
              <Radio.Button value="30Days">Last 30 Days</Radio.Button>
              <Radio.Button value="90Days">Last 90 Days</Radio.Button>
            </Radio.Group>
          </TabPane>
          <TabPane tab="Specific Dates" key="2">
            <div className="d-flex align-items-center">
              <div className="mr-5">
                <label htmlFor="" className="mr-3">Start Date</label>
                <DatePicker
                  value={this.state.startDate ? moment(this.state.startDate) : ''}
                  format={dateFormat}
                  allowClear={false}
                  style={{ width: '150px' }}
                  onChange={this.handleStartDate}
                  disabledDate={(current) => {
                    const customDate = moment().add(1, 'day').format(dateFormat);
                    return current && current > moment(customDate, dateFormat);
                  }}
                />
              </div>
              <div>
                <label htmlFor="" className="mr-3">End Date</label>
                <DatePicker
                  value={this.state.endDate ? moment(this.state.endDate) : ''}
                  format={dateFormat}
                  allowClear={false}
                  style={{ width: '150px' }}
                  disabled={!this.state.startDate}
                  onChange={this.handleEndDate}
                  disabledDate={(current) => {
                    const customDate = moment().add(1, 'day').format(dateFormat);
                    return current && current > moment(customDate, dateFormat);
                  }}
                />
              </div>
            </div>
          </TabPane>
        </Tabs>
      </Row>
      <Divider style={{ margin: '5px 0' }} />
      <span
        style={{
          display: 'block',
          fontSize: '14px',
          cursor: 'pointer',
          fontWeight: 'normal',
          margin: '7px 15px 7px',
          minHeight: '20px',
          color: '#808080',
        }}
        onClick={() => {
          this.props.clearAll();
          this.setState({ startDate: '' });
          this.setState({ endDate: '' });
          this.setState({ startD: '' });
          this.setState({ endD: '' });
          this.setState({ summaryType: 'Reset' });
        }}
      >
        Clear all
      </span>
    </Checkbox.Group>
  );

  render() {
    const DateboxRender = this.dateboxRender;
    return (
      <Popover
        // id="reporting_summary_popover"
        content={<DateboxRender />}
        trigger="click"
        placement="bottomLeft"
        onVisibleChange={this.changeBackgroundColor}
        overlayStyle={{
          marginTop: '0',
          paddingTop: '0',
          width: '650px',
          left: '15%',
        }}
        overlayClassName="reporting_summary_popover"
        style={{
          width: '650px',
          left: '15%',
        }}
        // getPopupContainer={triggerNode => triggerNode.parentNode}
      >
        <Button
          size="large"
          type="primary"
          style={{
            borderRadius: 0,
            borderWidth: 0,
            backgroundColor: this.state.defaultBackgroundColor,
            color: '#414141',
            height: 'auto',
            minWidth: '100px',
            maxWidth: '150px',
            minHeight: '40px',
            boxShadow: 'none',
          }}
        >
          <SpH5 color="#414141" fontWeight="bold">{this.props.title}</SpH5> <Icon type="caret-down" {...this.state.icon} />
        </Button>
      </Popover>
    );
  }
}
export default DateMenu;
